module.exports = __webpack_public_path__ + "static/media/muavin2.90d1da48.svg";